import { FormSectionElements, FormSections, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import validator from 'validator'
import Utils from "./Utils";
import { StringUtils } from "@azure/msal-browser";

export default class FormValidationUtils {
    static
      // The month value should be 0-based, so subtract 1 from it
      evalPhonedRegularExpression(field: FormSectionElements) {
        let val = field.Value?.replace(/\s+|-+/g, ''); // Remove spaces and hyphens
        if (!val) return;
    
        const regex = /^\d{10}$/; // Ensures exactly 10 digits
        if (regex.test(val)) {
            field.Valid = true;
            const match = val.match(/^(\d{3})(\d{3})(\d{4})$/);
            field.Value = `(${match![1]}) ${match![2]}-${match![3]}`;
        } else {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty = val.length === 0;
        }
    }
    

    static controlValid(control: FormSectionElements) {
        if (control.Optional == 'Y') {
            return true;
        }

        if (control.Value == "" || control.Value == null) {
            return false;
        }

        return true;
    }

    static isValidDate(dateString) {
        if (!dateString) {
            return false;
        }
        // Split the date string into month, day, and year
        const [month, day, year] = dateString.split('/');

        // Create a new Date object using the provided values
        // The month value should be 0-based, so subtract 1 from it
        const date = new Date(year, month - 1, day);

        // Check if the parsed date is valid
        // Valid date should have the same values for year, month, and day as the input
        // Additionally, make sure the year is within a reasonable range (e.g., 1900-2099)
        return (
            date.getFullYear() == year &&
            date.getMonth() + 1 == month &&
            date.getDate() == day &&
            year >= 1900 &&
            year <= 2099
        );
    }

    static isDateTime(value) {
        const dateObject = new Date(value);
        return !isNaN(dateObject.getTime());
    }

    static runJavascript(field: FormSectionElements) {
        if (field.Script && Utils.isNotNullOrEmpty(field.Script)) {
             try {
                const customJSFunc = eval(`(${field.Script})`);
                if (customJSFunc && typeof customJSFunc === 'function') {
                    customJSFunc(field, process.env);
                }
            } catch (ex) {
                console.log(ex);
            }

        }
    }

    static runInitJavascript(field: FormSectionElements) {
        if (field.InitScript && Utils.isNotNullOrEmpty(field.InitScript)) {
             try {
                const customJSFunc = eval(`(${field.InitScript})`);
                if (customJSFunc && typeof customJSFunc === 'function') {
                    customJSFunc(field, process.env);
                }
            } catch (ex) {
                console.log(ex);
            }

        }
    }
    static runKeyStrokeJavascript(field: FormSectionElements) {
        if (field.KeyStrokeScript && Utils.isNotNullOrEmpty(field.KeyStrokeScript)) {
             try {
                const customJSFunc = eval(`(${field.KeyStrokeScript})`);
                if (customJSFunc && typeof customJSFunc === 'function') {
                    customJSFunc(field, process.env);
                }
            } catch (ex) {
                console.log(ex);
            }

        }
    }

    static invalidControls(formSection: FormSections) {

        let invalidList: FormSectionElements[] = [];
        let fieldList: FormSectionElements[] = [];

        formSection.ListOfFormSubSections.forEach((sub) => {
            sub.ListOfFormSectionElements.forEach(field=>{
                if(field.Visible && field.Datatype!='HiddenField'){
                     if(field.Datatype!='Row'){
                        fieldList.push(field)
                    } else {
                        field.subSectionList[0].ListOfFormSectionElements.forEach(field=>{
                            fieldList.push(field);
                        })
                    }

                }
            })
        })

        if (fieldList.length == 0) {
            return invalidList;
        }

        fieldList.forEach((field: FormSectionElements) => {
            FormValidationUtils.validate(field);
            console.log(field);
            if (!field.Valid) {
                invalidList.push(field);
            } else {
                FormValidationUtils.runJavascript(field);
                if (!field.Valid) {
                    if (invalidList.filter(p => p.Id == field.Id).length == 0) {
                        invalidList.push(field);
                    }
                }
            }
        })

        return invalidList;
    }

    static validate(field: FormSectionElements) {
        switch (field.Datatype) {
            case "Address":
                // console.log(`address: ${field.Valid}; ${field.Value}`);
                if (field.Valid) {
                    if (!field.Address && field.Optional !== 'Y') {
                        field.Touched = true;
                        field.Valid = false;
                        field.ErrorMessage = field.EmptyErrorMessage || (field.addressType==='Mailing' ? "Mailing": "Residential") + " address must be entered";
                        field.ErrorMessageFRA =field.EmptyErrorMessageFRA || (field.addressType==='Mailing'?  "L'adresse postale doit être renseignée" : "L’adresse résidentielle doit être saisie");
                        return;
                    }

                    if (field.Value && field.Value.length > 0) {
                        // const addressRegex = /^(?:((PART\s+)?LOT)|(PART BLOCK)\s\d+\s-\s)?(?:SUITE|APT|UNIT\s\d+\s-\s)?(?:[\d\s\w\.-]+(?:\s-\s[\d\s\w\.-]+)?(?:\s(odd|even))?),\s[A-Za-z\s\d]+(?:,\s[A-Za-z\s]+)*,\s(?:ON),\s[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/gmi;
                        const addressRegex = /^(?:((PART\s+)?LOT)|(PART BLOCK)\s\d+\s-\s)?(?:SUITE|APT|UNIT\s\d+\s-\s)?(?:[\d\s\w\.-]+(?:\s-\s[\d\s\w\.-]+)?(?:\s(odd|even))?)(,)?\s[A-Za-z\s\d\']+(?:,\s[A-Za-z\s]+)*,\s(?:ON),\s[A-Za-z]\d[A-Za-z]\s?\d[A-Za-z]\d$/gmi
                        if (!addressRegex.test(field.Value)) {
                            field.Valid = false;
                            field.Touched = true;
                            field.ErrorMessage = field.ErrorMessage || "Address is invalid";
                            field.ErrorMessageFRA = field.ErrorMessageFRA || "L'adresse est invalide";
                            return;
                        }
                    }
                    FormValidationUtils.validateText(field);
                }
                break;
            case "Currency":
                FormValidationUtils.validateCurrency(field);
                break;
            case "Text":
                FormValidationUtils.validateText(field);
                FormValidationUtils.evalRegularExpression(field);
                break;
            case "SelectWithRichText":
                FormValidationUtils.validateSelectWithRichText(field);
                break;
            case "CheckGroup":
                FormValidationUtils.validateCheckGroup(field);
                break;
            case "Checkbox":
                FormValidationUtils.validateCheckbox(field);
                break;
            case "RadioButton":
                FormValidationUtils.validateRadioButton(field);
                break;
            case "HealthCard":
                FormValidationUtils.validateHealthCard(field);
                FormValidationUtils.evalHeathCardRegularExpression(field)
                break;
            case "LicensePlate":
                FormValidationUtils.validateLicensePlate(field);
                break;
            case "BusinessNumber":
                FormValidationUtils.validateBusinessNumber(field);
                break;
            case "DriverLicense":
                FormValidationUtils.validateDriverLicense(field);
                break;
            case "Email":
            case "EmailConfirmation":
                FormValidationUtils.validateEmail(field);
                break;
            case "PhoneNumber":
                FormValidationUtils.validatePhoneNumber(field);
                break;
            case "Date":
                FormValidationUtils.validateDate(field);
                break;
            case "Number":
                FormValidationUtils.validateNumber(field);
                break;
            case "ODSDate":
                FormValidationUtils.validateODSDate(field);
                break;
            case "PostalCode":
                FormValidationUtils.validatePostalCode(field);
                break;
            case "CheckboxWithTextbox":
                FormValidationUtils.validateCheckbobWithInput(field);
                break;
            case "CheckboxWithInlineTextbox":
                FormValidationUtils.validateCheckbobWithInput(field);
                break;
            case "File":
                FormValidationUtils.validateFileUpload(field);
                break;
            case "Row":
                FormValidationUtils.validateRow(field);
        }
    }

    static validateRow(field: FormSectionElements){
        field.subSectionList[0].ListOfFormSectionElements.forEach(item=>{
            FormValidationUtils.validate(item);
        })
    }

    static validatePostalCode(field: FormSectionElements) {
        const val = field.Value;
        if (val) {
            if (!validator.isPostalCode(val, "CA")) {
                // field.ErrorMessage = "Postal Code invalid";
                field.Valid = false;
                field.Touched = true;
            } else {
                field.Valid = true;
            }
        } else {
            if (field.Optional == "N") {
                field.Valid = false;
                field.Touched = true;
            }
        }
    }

    static validateODSDate(field: FormSectionElements) {
        const val = field.Value;

        if (val) {
            if (field.Optional != 'Y' && Object.keys(val).length === 0) {
                field.Valid = false;
                field.Touched = true;
                field.IsEmpty=true;
            } else if ( field.Optional == 'Y' && Object.keys(val).length === 0) {
                field.Valid = true;
            } else if (!FormValidationUtils.isValidDate(val)) {
                    field.Valid = false;
                    field.Touched = true;
                    field.IsEmpty=false;
            } else {
                field.Valid = true;       
            }
        } else if (field.Optional != 'Y') {
            field.Valid = false;
            field.Touched = false;
            field.IsEmpty=true;
        } else {
            field.Valid = true;
        }
    }

    static validateNumber(field: FormSectionElements) {

        const val = field.Value;
        if (field.Optional !== 'Y' && !Utils.isNotNullOrEmpty(val)) {
            //    field.ErrorMessage = field.ErrorMessage == null ? field.ENUTitle + " is required" : field.ErrorMessage;
            field.Valid = false;
            field.Touched = true;
        } else {
            if (val != null && !validator.isFloat(val)) {
                //       field.ErrorMessage = field.ErrorMessage == null ? field.ENUTitle + " is invald" : field.ErrorMessage;
                field.Valid = false;
                field.Touched = true;
            } else {
                field.Valid = true;
            }
        }
    }
    static validateDate(field: FormSectionElements) {
        const val = field.Value;
         if (field.Optional != 'Y') {
            if(val==null){
                field.Valid = false
                field.Touched = true;         
            } else {
                field.Valid = true;
            }
        } else {
            field.Valid=true;
        }
    }

    static validateCurrency = (field: FormSectionElements) => {
        const val = field.Value;

        if (val == null || !validator.isNumeric(val)) {
            field.Valid = false;
            field.Touched = true;
        } else {
            const numberVal = Number.parseFloat(val);
            if ((field.MinValue != null && field.MinValue <= numberVal) && (field.MaxValue != null && numberVal <= field.MaxValue)) {
                field.Valid = true;
            } else {
                field.Touched = true;
                field.Valid = false;
            }
        }
    }

    static validateText = (field: FormSectionElements) => {
        const val = field.Value;
        if (field.Optional == "N" && !val) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty=true;
        } else {
            field.Valid = true;
        }
    }

    static evalRegularExpression = (field: FormSectionElements) => {
        const val = field.Value;
        if (field.Valid) {
            if (field.RegularExpression) {
                var regexPattern = new RegExp(field.RegularExpression);
                var isMatch = regexPattern.test(val);
                if (!isMatch) {
                    field.Valid = false;
                    field.Touched = true;
                    field.IsEmpty = false;
                }
            }
        }
    }

    static validateSelectWithRichText = (field: FormSectionElements) => {
        const val = field.Value;
        if (Utils.isNullOrEmpty(field.SelectionCode)) {
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }
    }

    static validateCheckGroup = (field: FormSectionElements) => {

        const val = field.Value;
        if (field.Optional == "N" && (val == "" || val == null)) {
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }
    }

    static validateRadioButton = (field: FormSectionElements) => {

        const val = field.Value;
        if (field.Optional == "N" && Utils.isNullOrEmpty(val)) {
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }

    }

    static validateCheckbox = (field: FormSectionElements) => {
        const val = field.Value;
        if ("Y" != field.Optional && (Utils.isNullOrEmpty(val) || val == "N" || val == false)) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty=true;
        } else {
            field.Valid = true;
        }
    }

    static validateHealthCard = (field: FormSectionElements) => {
       
        const val = field.Value;
        if ((field.Optional !== "Y" && Utils.isNullOrEmpty(val))) {
            // field.ErrorMessage = "Health Card Number is invalid";
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty=true;
        } else {
            field.Valid = this.healthCardOnInputValidation(val, field);
            field.Touched = true;
            field.IsEmpty = false;
        }


      
    }

    static evalHeathCardRegularExpression = (field: FormSectionElements) => {
        const val = field.Value?.replace(/\s+|-+/g, '');
        const regex = /^(\d{4})(\d{3})(\d{3})([a-z]{2})$/gi;
        if (regex.test(val)) {
            field.Valid = true;
            field.Value = val.replace(regex, '$1-$2-$3-$4').toUpperCase();
        } else {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty = false;
        }
        
        // if (field.Valid) {
        //     const pattern = /^[0-9]{4}(?:[-\s]*)[0-9]{3}(?:[-\s]*)[0-9]{3}(?:[-\s]*)(?:[a-zA-Z]{2})$/;0750023454167326747

        //     if (!pattern.test(val)) {
        //         field.Valid = false;
        //         field.Touched = true;
        //         field.IsEmpty = false;
        //     }
        // }
    }

    static evalDriversLicenseCardRegularExpression = (field: FormSectionElements) => {
        const val = field.Value;
        if (field.Valid) {
            const pattern = /^([A-Za-z]\d{4})[-]?(\d{5})[-]?(\d{5})$/;

            if (!pattern.test(val)) {
                field.Valid = false;
                field.Touched = true;
                field.IsEmpty = false;
            }
        }
    }


    static validateLicensePlate = (field: FormSectionElements) => {
        const pattern = /^[A-Za-z0-9 ]{2,8}$/;
        if ((field.Optional == "N" && Utils.isNullOrEmpty(field.Value))) {
            //   field.ErrorMessage = "Plate Number is invalid";
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty = true;
        } else if  (Utils.isNotNullOrEmpty(field.Value) && !pattern.test(field.Value)) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty = false;
        } else {
            field.Valid = true;
        }
    }

    static validateBusinessNumber = (field: FormSectionElements) => {
        const pattern = /^[0-9]{9}([A-Z]{2}[0-9]{4})?$/;
        if ((field.Optional == "N" && Utils.isNullOrEmpty(field.Value)) || !pattern.test(field.Value)) {
            // field.ErrorMessage = this.props.langCo=="En"? "Business Number is invalid" :"Le numéro d'entreprise saisi est invalide";
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }
        console.log(field)
    }
    static validateDriverLicense = (field: FormSectionElements) => {
        const pattern = /^([A-Za-z]\d{4})[-]?(\d{5})[-]?(\d{5})$/;
        if ((field.Optional == "N" && Utils.isNullOrEmpty(field.Value)) || !pattern.test(field.Value)) {
            //   field.ErrorMessage = "Driver's License is invalid";
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }
    }
    static validateEmail = (field: FormSectionElements) => {
        if (field.Optional != 'Y') {
            if ((Utils.isNullOrEmpty(field.Value))) {
                //   field.ErrorMessage = "Email is invalid";
                field.Valid = false;
                field.Touched = true;
                field.IsEmpty=true;
                return;
            } else {
                field.Valid = true;
            }
        }

        if (field.Valid && Utils.isNotNullOrEmpty(field.Value) && !validator.isEmail(field.Value)) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty = false;
        } else {
            field.Valid = true;
        }
    }

    static validatePhoneNumber = (field: FormSectionElements) => {
         if ((field.Optional == "N" && Utils.isNullOrEmpty(field.Value))) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty=true;
        } else {
            field.Valid = true;
        }

        if (!Utils.isNullOrEmpty(field.Value) && !validator.isMobilePhone(field.Value, "en-CA")) {
            field.Valid = false;
            field.Touched = true;
            field.IsEmpty=false;
        }

        if (!Utils.isNullOrEmpty(field.Value) && validator.isMobilePhone(field.Value, "en-CA")) {
            let val=field.Value;
            const digitsOnly = val.replace(/\D/g, ''); // \D = non-digit
            const match = digitsOnly.match(/^(\d{3})(\d{3})(\d{4})$/);
            field.Value = `(${match![1]}) ${match![2]}-${match![3]}`;
        }
    }

    static validateDropdown = (field: FormSectionElements) => {
        if (field.Optional == "N" && Utils.isNullOrEmpty(field.Value)) {
            field.Valid = false;
            field.Touched = true;
        } else {
            field.Valid = true;
        }
    }

    static validateCheckbobWithInput = (field: FormSectionElements) => {
        const val = field.Value;
        const programContainer = field.parent.parent.parent;
        //console.log(programContainer)
        const isComplete = programContainer.IsComplete;
        //console.log(isComplete)
        if (isComplete) {
            field.Valid = true;
        } else {
            if ((field.Checked && !val) || (val && !field.Checked)) {
                field.Valid = false;
                field.Touched = true;
                field.IsEmpty = true;
            } else {
                field.Valid = true;
            }

            if (field.Valid) {
                const pattern = /^[0-9]{9}([A-Z]{2}[0-9]{4})?$/;
                if (field.Checked && (Utils.isNullOrEmpty(field.Value) || !pattern.test(field.Value))) {
                    field.Valid = false;
                    field.Touched = true;
                    field.IsEmpty = false;
                } else {
                    field.Valid = true;
                }
            }
        }
    }

    static validateFileUpload = (field: FormSectionElements) => {
        const value = field.Value;
        if ((!Array.isArray(value) || value?.length===0) && field.Optional === 'N') {
            field.Valid = false;
            field.IsEmpty = true;
            field.Touched = true;
            field.ErrorMessage = field.EmptyErrorMessage || 'File must to be uploaded';
            field.ErrorMessageFRA = field.EmptyErrorMessageFRA || 'Le fichier doit être téléchargé';
        } else {
            field.Valid = true;
            field.IsEmpty = false;
            field.ErrorMessage = null;
            field.ErrorMessageFRA = null;
        }
    }

    static getTechSection=(programContainer: ProgramContainer)=>{
        const forms= programContainer.ListOfFormSections.filter(p=>p.IsTechErrorPage);
        if(forms.length>0){
            return forms[0];
        }

        return null;
    }

    static getSectionIndex=(programContainer: ProgramContainer, sectionTitle: string)=>{
        const index= programContainer.ListOfFormSections.findIndex(p=>p.ENUTitle==sectionTitle);
        return index;
    }

    static resetSectionValidation=(section: FormSections)=>{
        section.ListOfFormSubSections.forEach(sub=>{
            sub.ListOfFormSectionElements.forEach(field=>{
                field.Valid=true;
                field.ErrorMessage=null;
                field.ErrorMessageFRA=null;
            })
        })
    }

    static healthCardOnInputValidation = (value: string, field: FormSectionElements) => {
        if (value.startsWith('0')) {
            return false;
        }

        const regex1 = "(\\d{4})";
        const regex2 = "(\\d{3})";
        const part1 = 4, part2 = 3, part3 = 3, part4 = 2;
        const val = value.replace(/\s+|-+/g, '');
        let regex = null;
        let fregex = null;

        if (val.length <= part1) {
            regex = new RegExp(`^\\d{${val.length}}$`);
            if (regex.test(val)) {
                field.Value = val.length === part1 ? val + '-' : val;
                return true;
            }
            return false;
        }

        if (val.length <= (part1 + part2)) {
            regex = new RegExp(`^${regex1}(\\d{${val.length - part1}})$`);
            if (regex.test(val)) {
                const value = val.replace(regex, '$1-$2');
                field.Value = val.length === (part1 + part2) ? value + '-' : value;
                return true;
            }
            return false;
        }

        if (val.length <= (part1 + part2 + part3)) {
            regex = new RegExp(`^${regex1}${regex2}(\\d{${val.length - part1 - part2}})$`);
            if (regex.test(val)) {
                const value = val.replace(regex, '$1-$2-$3');
                field.Value = val.length === (part1 + part2 + part3) ? value + '-' : value;
                return true;
            }
            return false;
        }

        if (val.length <= (part1 + part2 + part3 + part4)) {
            regex = new RegExp(`^${regex1}${regex2}${regex2}([a-z]{${val.length - part1 - part2 - part3}})$`, 'ig');
            if (regex.test(val)) {
                field.Value = val.replace(regex, '$1-$2-$3-$4').toUpperCase();
                return true;
            }  
            return false;
        }
        return false;
    }

    static isDelOrBackspaceKey = (e: React.KeyboardEvent<HTMLInputElement>) => {
        return e.key === 'Delete' || e.key === 'Backspace';
    }
}